import { Events } from './events';
import { Scene } from './scene';

const initPicturesRuntime = (scene: Scene, events: Events) => {
    // 2D overlay (HUD)
    const container = window.document.getElementById('canvas-container');
    if (!container) {
        return;
    }

    const overlay = window.document.createElement('div');
    overlay.setAttribute('id', 'pictures-overlay');
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.display = 'none';
    overlay.style.pointerEvents = 'none';
    overlay.style.zIndex = '3';

    // Keep it unobtrusive by default: centered, fit-to-container.
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';

    const img = window.document.createElement('img');
    img.setAttribute('alt', '');
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.style.objectFit = 'contain';

    overlay.appendChild(img);
    container.appendChild(overlay);

    const update = () => {
        const usable = !!events.invoke('picture.enabled') && !events.invoke('camera.posesNeedsValidation');
        const overlayEnabled = !!events.invoke('pictures.overlay.enabled');
        const selectedId = events.invoke('pictures.selectedId') as string | null;
        const url = events.invoke('pictures.imageUrl', selectedId) as string | null;

        const shouldShow = usable && overlayEnabled && !!url;
        overlay.style.display = shouldShow ? 'flex' : 'none';
        img.src = shouldShow ? url : '';
    };

    events.on('pictures.overlay.enabledChanged', update);
    events.on('picture.enabledChanged', update);
    events.on('camera.posesValidationChanged', update);
    events.on('pictures.selectedChanged', update);
    events.on('pictures.imageChanged', update);
    events.on('scene.clear', update);

    update();
};

export { initPicturesRuntime };
